<template>
  <div class="price-and-button d-flex flex-column">
    <div
      class="d-flex align-items-center justify-content-between w-100 total-price-row"
    >
      <p class="heading mb-1">{{ $t('reservations.total') }}</p>
      <Price :price="booking.sellingPrice" class="heading" />
    </div>

    <ReserveActionsButton
      v-if="showReserveButton && !hideActionButton"
      class="mt-3 reserve-actions-wrapper"
      :booking="booking"
      :default-label="buttonText"
      button-class="reserve-button"
    />
    <ReserveActionsButton
      v-else-if="showPayBalanceButton && !hideActionButton"
      class="mt-3 reserve-actions-wrapper"
      :booking="booking"
      :default-label="payActionLabel"
      button-class="reserve-button"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import Price from '@/components/common/Price.vue'
import { BookingSummary } from '@/services/BookingService.interface'
import ReserveActionsButton from '@/components/common/ReserveActionsButton.vue'
import { useBookingFunnelActions } from '@/composables/useBookingFunnelActions'
import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'

const props = defineProps({
  buttonText: {
    type: String,
    required: true,
  },
  booking: {
    type: Object as () => BookingSummary,
    required: true,
  },
  /** Panel mobile: CTA is in StickyBar to avoid duplicate Réserver. */
  hideActionButton: {
    type: Boolean,
    default: false,
  },
})

const { showReserveButton, showPayBalanceButton } = useBookingFunnelActions(
  () => props.booking
)
const { payActionLabel } = useBookingFunnelNavigation(() => props.booking)
</script>

<style scoped>
@media (max-width: 768px) {
  .reserve-actions-wrapper :deep(.reserve-button) {
    width: calc(100% - 2rem);
    margin: 0 auto;
  }
}

@media (min-width: 769px) {
  .reserve-actions-wrapper :deep(.reserve-button) {
    width: 33%;
    margin-left: auto;
  }
}
</style>
